import InputField from "../../components/Auth/InputField";
import useTranslator from "../../hooks/useTranslator";
import { PhoneInput } from "react-international-phone";
import AuthStepHeader from "../../components/Auth/AuthStepHeader";
import { Button, Control, Field } from "../../components/design";
import "../../components/Auth/AuthForm.css";

const LLBasicInfo = ({
  title,
  subtitle,
  userLogin,
  onChangeHandler,
  setUserLogin,
  submitHandler,
  setCurrentScreen,
}) => {
  const { _t } = useTranslator();
  return (
    <>
      <form onSubmit={submitHandler} className="auth-step">
        <AuthStepHeader
          onBack={() => setCurrentScreen?.("signup")}
          title={title}
          subtitle={subtitle}
        />
        <div className="auth-field-row">
          <InputField
            name={"fname_companyName"}
            isHalf={true}
            value={userLogin?.fname_companyName ?? ""}
            label={"firstName"}
            onChange={onChangeHandler}
            onBeforeInput={(e) => {
              const isValidChar = /^[A-Za-zÀ-ÿ\s'-]+$/.test(e.data);
              if (!isValidChar) e.preventDefault();
            }}
          />
          <InputField
            name={"lname"}
            isHalf={true}
            value={userLogin?.lname ?? ""}
            label={"lastName"}
            onChange={onChangeHandler}
            onBeforeInput={(e) => {
              const isValidChar = /^[A-Za-zÀ-ÿ\s'-]+$/.test(e.data);
              if (!isValidChar) e.preventDefault();
            }}
          />
        </div>
        <Field label={_t("phoneNumber")}>
          <Control>
            <PhoneInput
              international
              defaultCountry={"es"}
              value={userLogin?.phone}
              inputProps={{
                required: true,
              }}
              onChange={(e) =>
                setUserLogin((prev) => ({
                  ...prev,
                  phone: e?.replace("+", "") || "",
                }))
              }
            />
          </Control>
        </Field>
        <Button type="submit" size="lg" block>
          {_t("submit")}
        </Button>
      </form>
    </>
  );
};
export default LLBasicInfo;
